import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/button-icons/tick-icon-white.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-110d98b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "number",
  "data-test": "progress-circle-number"
}
const _hoisted_2 = {
  key: 1,
  src: _imports_0,
  alt: "completed",
  class: "completed-progress-icon",
  "data-test": "progress-circle-img"
}

import { computed } from "vue";
import { Status } from "../../typings/shared/status";
import { Variant } from "../../typings/shared/levels-variant";


export default /*#__PURE__*/_defineComponent({
  __name: 'progress-circle',
  props: {
    number: {},
    status: {},
    variant: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "5770ea2d": (bgColour.value)
}))

const props = __props;

const bgColour = computed(() => {
  if (props.variant === "team") {
    return "#b0bb36";
  }
  if (props.variant === "user") {
    return "#FCAF17";
  }
  return "#000000";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["progress-circle", props.status]),
    "data-test": "progress-circle"
  }, [
    (_ctx.status === 'active')
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.number), 1))
      : (_ctx.status === 'completed')
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : _createCommentVNode("", true)
  ], 2))
}
}

})